import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { PublicHeader, PublicFooter } from '../components/PublicLayout';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';
import { CheckCircle, Loader2, ArrowRight } from 'lucide-react';
import api from '../lib/api';

export default function SubscriptionSuccessPage() {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('checking');
  const [packageId, setPackageId] = useState('');
  const sessionId = searchParams.get('session_id');

  useEffect(() => {
    if (sessionId) pollStatus(sessionId);
    else setStatus('error');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sessionId]);

  const pollStatus = async (sid, attempts = 0) => {
    if (attempts >= 10) { setStatus('timeout'); return; }
    try {
      const res = await api.get(`/api/payments/status/${sid}`);
      if (res.data.payment_status === 'paid') {
        setStatus('success');
        setPackageId(res.data.package_id);
        return;
      }
      setTimeout(() => pollStatus(sid, attempts + 1), 2000);
    } catch { setTimeout(() => pollStatus(sid, attempts + 1), 2000); }
  };

  return (
    <>
      <PublicHeader />
      <main className="bg-[#FBF7EF] min-h-screen flex items-center justify-center">
        <Card className="max-w-md w-full mx-4 bg-white border-[#E7E0D6]">
          <CardContent className="pt-10 pb-8 text-center">
            {status === 'checking' && (
              <><Loader2 className="w-12 h-12 mx-auto mb-4 animate-spin text-[#B89B5E]" /><h2 className="text-xl font-bold">Processing Payment...</h2><p className="text-sm text-[#5B616E] mt-2">Please wait while we confirm your subscription.</p></>
            )}
            {status === 'success' && (
              <><CheckCircle className="w-16 h-16 mx-auto mb-4 text-[#1F7A5A]" /><h2 className="text-2xl font-bold news-masthead">Welcome to {packageId?.charAt(0).toUpperCase()}{packageId?.slice(1)}!</h2><p className="text-sm text-[#5B616E] mt-2">Your subscription is now active. Enjoy premium content!</p><Link to="/"><Button className="mt-6 bg-[#121316] text-white hover:bg-[#1B1D22]">Start Reading <ArrowRight className="w-4 h-4 ml-2" /></Button></Link></>
            )}
            {(status === 'timeout' || status === 'error') && (
              <><h2 className="text-xl font-bold">Something went wrong</h2><p className="text-sm text-[#5B616E] mt-2">Please check your email for confirmation or contact support.</p><Link to="/subscription"><Button variant="outline" className="mt-4">Back to Plans</Button></Link></>
            )}
          </CardContent>
        </Card>
      </main>
      <PublicFooter />
    </>
  );
}
